import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import I18n from "i18n";
import { CouponItem } from "./couponApi";
import CouponForm from "./CouponForm";
import useCouponList from "./useCouponList";

export interface CouponListProps extends Omit<DataGridBaseBaseProps, "id"> {
  showHeader?: boolean;
}

export default function CouponList({
  showHeader = true,
  ...props
}: CouponListProps) {
  const { params, scope, editUrl, ...service } = useCouponList();
  let columns: GridColumns<CouponItem> = [
    {
      field: "code",
      headerName: I18n.t("Coupon.attributes.code"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
    {
      field: "discount_percent",
      headerName: I18n.t("Coupon.attributes.discount_percent"),
      flex: 1,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<ConfirmationNumberIcon />}
          title={I18n.t("Coupon.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="coupons"
        renderModalForm={props => <CouponForm {...props} />}
        modalProps={{ maxWidth: "sm" }}
        {...props}
        canCreate={true}
        canDelete={true}
        canEdit={true}
        canDeleteRow={() => true}
        canEditRow={() => true}
        canBatchActions={true}
        canHandleTrash={true}
      />
    </>
  );
}
